import { useQuery } from '@tanstack/react-query';
import { mealNoteService } from '@/services/mealNoteService';
import { format } from 'date-fns';

export const useMealNotes = (startDate: Date, endDate: Date, familyId?: string) => {
  const startDateStr = format(startDate, 'yyyy-MM-dd');
  const endDateStr = format(endDate, 'yyyy-MM-dd');

  return useQuery({
    queryKey: ['mealNotes', startDateStr, endDateStr, familyId],
    queryFn: () => mealNoteService.getMealNotesByDateRange(startDateStr, endDateStr),
    enabled: !!familyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};